import { useMemo, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJModal from '../FJModal';
import FJPreviewModal from './FJPreviewModal';
import FJConstant from '../../../constants/FJConstant';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionModal from '../../../redux/action/FJActionModal';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import FJRequirementsUtil from '../../../util/FJRequirementsUtil.js';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
import FJAppConstant from '../../../constants/FJAppConstant.js';
import FJActionAIVideoGenerator from '../../../redux/action/FJActionAIVideoGenerator.js';
import FJAIToolUtil from '../../../util/FJAIToolUtil.js';
import FJUtil from '../../../util/FJUtil.js';
import { VIDEO_EFFECT_STYLE_LIST } from '../../../config/dataConfig/FJVideoEffectData.js';
import FJAIVideoGeneratorConfig from '../../../config/appConfig/FJAIVideoGeneratorConfig.js';

const FJPreviewModalContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const previewModalData = useSelector(state => state.modals.previewModalData);
    const historyList = useSelector(state => state.common.historyList);
    const creationList = useSelector(state => state.common.creationList);
    const commonAppType = useSelector(state => state.common.appType);
    const isApplyButton = useSelector(state => state.common.isApplyButton);
    const addAsEditPageModalBtuStatus = useSelector(state => state.modals.addAsEditPageModalBtuStatus);
    const { display, data = {} } = previewModalData;
    const {
        id,
        type,
        imgUrl,
        videoUrl,
        audioUrl,
        width,
        height,
        garment,
        previewList: previewListData,
        appType: communityAppType,
        shareKey,
    } = data;
    const appType = communityAppType || commonAppType;

    const sortType = useSelector(state => state.AIVideoGenerator.sortType);
    const isAudioGenerator = appType === FJAppConstant.AI_AUDIO_GENERATOR;
    const isVideoGeneration = appType === FJAppConstant.AI_VIDEO_GENERATOR;
    const isVideoRemoveBg = appType === FJAppConstant.VIDEO_REMOVE_BG;
    const isVideoDub = appType === FJAppConstant.AI_VIDEO_DUB;
    const historyTabIndex = useSelector(state => state.AIAudioGenerator.historyTabIndex);

    useEffect(() => {
        if (FJUtil.isAiVideoGeneratorLandingPage()) {
            const dom = document.getElementById('ai-tool-banner-container');
            if (display) {
                dom && (dom.style.zIndex = 9);
            } else if (!display) {
                dom && (dom.style.zIndex = '');
            }
        }
    }, [display]);
    const videoEffectStyleItem = useMemo(() => {
        if (data.jobType === FJAIVideoGeneratorConfig.videoEffectJobType) {
            return VIDEO_EFFECT_STYLE_LIST.find(item => item.category === data.effectInfo.effect_scene) || {};
        }
        return {};
    }, [data]);

    const onClose = useCallback(() => {
        dispatch(FJActionModal.hidePreviewModalDataAction());
    }, [dispatch]);

    const onDownload = callback => {
        dispatch(
            FJActionCommon.multiDownloadAction([id], 'preview', callback, {
                appType: appType,
                previewList: previewList,
            }),
        );
    };
    const onDelete = () => {
        let index = previewList.findIndex(item => item.id === id);
        dispatch(
            FJActionCommon.multiDeleteAction([id], list => {
                if (!list) return;
                if (!list.length) {
                    onClose();
                    return;
                }
                if (commonAppType === FJAppConstant.AI_COMMUNITY) {
                    const newList = previewList.filter(item => item.id !== id);
                    if (!newList.length) {
                        onClose();
                        return;
                    }
                    index >= newList.length && (index = newList.length - 1);
                    previewImage(newList[index], newList);
                } else if (isAudioGenerator || isVideoGeneration) {
                    const tempList = isVideoGeneration
                        ? FJRequirementsUtil.getSortHistoryList(list, sortType)
                        : FJRequirementsUtil.getAudioHistoryList(list, historyTabIndex);

                    let data = null;
                    for (let i = index; i < tempList.length; i++) {
                        const item = tempList[i];
                        if (item.status === 'completed') {
                            data = item;
                            break;
                        }
                    }
                    if (!data) {
                        for (let i = index; i >= 0; i--) {
                            const item = tempList[i];
                            if (item && item.status === 'completed') {
                                data = item;
                                break;
                            }
                        }
                    }
                    if (data) {
                        previewImage(data);
                    } else {
                        onClose();
                    }
                } else {
                    index >= list.length && (index = list.length - 1);
                    previewImage(list[index]);
                }
            }),
        );
    };
    const addAsScene = () => {
        dispatch(FJActionModal.addAsEditPageAction([id], undefined, { appType: appType, previewList: previewList }));
    };
    const _addToMedia = () => {
        let url = imgUrl;
        if (FJAIToolUtil.getVideoAppTypeList().includes(appType)) url = videoUrl;
        else if (isAudioGenerator) url = audioUrl;
        dispatch(FJActionEditPage.addToMediaLibraryAction(url, { from: 'generate' }));
    };
    const _onApply = () => {
        let url = imgUrl;
        if (isVideoGeneration || isVideoRemoveBg || isVideoDub) url = videoUrl;
        else if (isAudioGenerator) url = audioUrl;
        onClose();
        let options;
        if (width && height) {
            options = {
                size: { width: width, height: height },
            };
        }
        dispatch(FJActionEditPage.applyToEditPageAction(url, options));
    };
    const shareToSociety = type => {
        if (shareKey) {
            const shareLink = FJUtil.getShareLink(shareKey);
            shareLink && FJUtil.shareToSociety(type, shareLink);
        } else {
            dispatch(FJActionModal.shareToSocietyAction(id, type));
        }
    };
    const previewImage = (data, previewList) => {
        dispatch(
            FJActionModal.showPreviewModalDataAction({
                data: { ...data, previewList: previewList || previewListData },
            }),
        );
    };
    const previewList = useMemo(() => {
        if (previewListData) return previewListData;
        if (isAudioGenerator) {
            return FJRequirementsUtil.getAudioHistoryList(historyList, historyTabIndex);
        }
        if (type === FJConstant.HISTORY) {
            if (isVideoGeneration) {
                return FJRequirementsUtil.getSortHistoryList(historyList, sortType);
            } else {
                return historyList;
            }
        } else {
            return creationList;
        }
    }, [
        type,
        historyList,
        creationList,
        isVideoGeneration,
        sortType,
        isAudioGenerator,
        historyTabIndex,
        previewListData,
    ]);
    const switchPreview = (isNext = true) => {
        const index = previewList.findIndex(item => item.id === id);
        const nextIndex = isNext ? index + 1 : index - 1;
        if (previewList[nextIndex]) {
            const item = previewList[nextIndex];
            if (isVideoGeneration || isAudioGenerator) {
                if (item.status === 'completed') {
                    previewImage(item);
                } else {
                    changePreviewByIndex(nextIndex, isNext);
                }
            } else {
                previewImage(item);
            }
        }
    };

    const changePreviewByIndex = (index, isNext) => {
        const nextIndex = isNext ? index + 1 : index - 1;
        if (previewList[nextIndex]) {
            const item = previewList[nextIndex];
            if (item.status === 'completed') {
                previewImage(item);
            } else {
                changePreviewByIndex(nextIndex, isNext);
            }
        }
    };

    const isActiveNext = useMemo(() => {
        if (isVideoGeneration || isAudioGenerator) {
            const currentIndex = previewList.findIndex(item => item.id === id);
            const willPreviewList = previewList.slice(currentIndex + 1);
            return currentIndex < previewList.length - 1 && willPreviewList.some(item => item.status === 'completed');
        } else {
            return previewList.findIndex(item => item.id === id) < previewList.length - 1;
        }
    }, [id, previewList, isAudioGenerator, isVideoGeneration]);
    const isActivePrevious = useMemo(() => {
        if (isVideoGeneration || isAudioGenerator) {
            const currentIndex = previewList.findIndex(item => item.id === id);
            const willPreviewList = previewList.slice(0, currentIndex);
            return currentIndex > 0 && willPreviewList.some(item => item.status === 'completed');
        } else {
            return previewList.findIndex(item => item.id === id) > 0;
        }
    }, [id, previewList, isAudioGenerator, isVideoGeneration]);

    const onEdit = useCallback(() => {
        onClose();
        dispatch(FJActionCommon.editHistoryItemAction(data, null, { position: 'preview' }));
    }, [dispatch, data, onClose]);

    const onEditSfx = useCallback(() => {
        onClose();
        dispatch(FJActionAIVideoGenerator.editAISfxAction(id, { previewList: previewList }));
    }, [dispatch, id, onClose, previewList]);

    return (
        <FJModal visible={display}>
            <FJPreviewModal
                isApplyButton={isApplyButton}
                appType={appType}
                addAsScene={addAsScene}
                onEditSfx={onEditSfx}
                addToMedia={_addToMedia}
                onApply={_onApply}
                shareToSociety={shareToSociety}
                onClose={onClose}
                data={data}
                onDownload={onDownload}
                onDelete={onDelete}
                onEdit={onEdit}
                isActiveNext={isActiveNext}
                isActivePrevious={isActivePrevious}
                switchPreview={switchPreview}
                addAsEditPageModalBtuStatus={addAsEditPageModalBtuStatus}
                active={display}
                isAudioGenerator={isAudioGenerator}
                isVideoGeneration={isVideoGeneration}
                isVideoRemoveBg={isVideoRemoveBg}
                isVideoDub={isVideoDub}
                garment={garment}
                videoEffectStyleItem={videoEffectStyleItem}
            />
        </FJModal>
    );
};
export default FJPreviewModalContainer;
